import React from "react";
import { Box, Typography, Button, Container, Grid, Paper } from "@mui/material";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar, Line } from "react-chartjs-2";
import Layout from "../components/layout/LandingPageLayout";
import {Link} from "react-router-dom"

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
);

// Dummy data for charts
const barData = {
  labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
  datasets: [
    {
      label: "Revenue (₹)",
      data: [12000, 19000, 15000, 22000, 28000, 35000],
      backgroundColor: "#42A5F5",
    },
    {
      label: "Expenses (₹)",
      data: [8000, 12000, 10000, 14000, 16000, 20000],
      backgroundColor: "#EF5350",
    },
  ],
};

const lineData = {
  labels: ["Week 1", "Week 2", "Week 3", "Week 4"],
  datasets: [
    {
      label: "Cash Flow",
      data: [3000, 6000, 4000, 8000],
      borderColor: "#66BB6A",
      backgroundColor: "rgba(102,187,106,0.2)",
      fill: true,
    },
  ],
};

const AnalyticsInfo = () => {
  return (
    <Layout>
      <Container maxWidth="lg" sx={{ py: 8 }}>
        {/* Header */}
        <Typography
          variant="h3"
          sx={{
            textAlign: "center",
            color: "primary.main",
            fontWeight: "bold",
            mb: 6,
          }}
        >
          Smarter Financial Analytics
        </Typography>

        {/* Intro Text */}
        <Typography
          variant="body1"
          sx={{
            textAlign: "center",
            color: "text.secondary",
            mb: 6,
            maxWidth: "700px",
            mx: "auto",
          }}
        >
          Our AI Accountant not only records your transactions but also helps
          you analyze reports with interactive charts and insights. Track your
          revenue, expenses, and cash flow in real-time to make smarter
          financial decisions.
        </Typography>

        {/* Charts Section */}
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Paper sx={{ p: 3, borderRadius: 3, boxShadow: 3 }}>
              <Typography
                variant="h6"
                sx={{ mb: 2, color: "primary.main", fontWeight: "bold" }}
              >
                Revenue vs Expenses
              </Typography>
              <Bar data={barData} options={{ responsive: true }} />
            </Paper>
          </Grid>

          <Grid item xs={12} md={6}>
            <Paper sx={{ p: 3, borderRadius: 3, boxShadow: 3 }}>
              <Typography
                variant="h6"
                sx={{ mb: 2, color: "primary.main", fontWeight: "bold" }}
              >
                Cash Flow Trend
              </Typography>
              <Line data={lineData} options={{ responsive: true }} />
            </Paper>
          </Grid>
        </Grid>

        {/* CTA Section */}
        <Box
          sx={{
            textAlign: "center",
            mt: 8,
            p: 4,
            borderRadius: 3,
            bgcolor: "background.paper",
            boxShadow: 3,
          }}
        >
          <Typography variant="h5" sx={{ mb: 2, fontWeight: "bold" }}>
            Get Insights That Drive Growth
          </Typography>
          <Button
            component={Link}
            to="/login"
            variant="contained"
            color="primary"
            size="large"
            sx={{ px: 4, py: 1.5, borderRadius: 2, textTransform: "none" }}
          >
            Try AI Analytics Today
          </Button>
        </Box>
      </Container>
    </Layout>
  );
};

export default AnalyticsInfo;
